export default __webpack_public_path__ + "./assets/gpt3.mp4";